import { Component, OnInit } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';

@Component({
  standalone: true,
  imports: [MatLegacyButtonModule, MatLegacyDialogModule],
  selector: 'app-script-block-dialog',
  templateUrl: 'script-block-dialog.component.html',
  styleUrls: ['script-block-dialog.component.scss'],
})
export class ScriptBlockDialogComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
